import { createStore } from "redux"; // import createStore from redux
import reducer from "./reducer"; // import the reducer

const store = createStore(reducer); // create the store with the reducer

export default store;
